import {
  audioFiles,
  NextNumberOutAudioFiles,
  playingFullHouseAudioFiles,
  playingSingleLineAudioFiles,
  playingTwoLineAudioFiles,
  welcomeAudioFiles,
  winnerDoubleLineAudioFiles,
  winnerFullHouseAudioFiles,
  winnerSingleLineAudioFiles,
  FirstNumberOutAudioFiles,
  thankyouMessageAudioFiles,
  gameEndAudioFiles,
  nextGameAudioFiles,
  winnerJackpotAudioFiles,
} from "../const/modules/audioFiles";

let currentAudio = null;

export async function playAudioFromCollection(audioCollection) {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }

  const length = Object.keys(audioCollection).length;
  if (length === 0) return;

  const randomIndex = Math.floor(Math.random() * length);
  const audioFile = audioCollection[randomIndex][0];

  currentAudio = new Audio(require(`@/assets/audio/${audioFile}`));

  return new Promise((resolve) => {
    currentAudio.onended = () => {
      currentAudio = null;
      resolve();
    };

    currentAudio.play();
  });
}

export async function playNumberAnnouncement(number) {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }

  if (audioFiles[number]?.length > 0) {
    const randomIndex = Math.floor(Math.random() * audioFiles[number].length);
    const selectedFile = audioFiles[number][randomIndex];

    currentAudio = new Audio(require(`@/assets/audio/${selectedFile}`));
    currentAudio.play();
  } else if ("speechSynthesis" in window) {
    window.speechSynthesis.cancel();
    const speech = new SpeechSynthesisUtterance(number.toString());
    speech.lang = "en-US";
    speech.rate = 1;
    speech.pitch = 1;
    setTimeout(() => window.speechSynthesis.speak(speech), 100);
  }
}

export async function speakNumber(number) {
  await playNumberAnnouncement(number);
}

export async function speakWinner(winningPattern) {
  switch (winningPattern) {
    case "ONE_LINE":
      return playAudioFromCollection(winnerSingleLineAudioFiles);

    case "TWO_LINE":
      return playAudioFromCollection(winnerDoubleLineAudioFiles);

    case "FULL_HOUSE":
      return playAudioFromCollection(winnerFullHouseAudioFiles);

    case "JACKPOT":
      return playAudioFromCollection(winnerJackpotAudioFiles);

    default:
      console.warn("Unknown winning pattern:", winningPattern);
      return Promise.resolve();
  }
}

export async function speakGameStart() {
  await playAudioFromCollection(welcomeAudioFiles);
  await speakGamePattern("ONE_LINE");
  await playAudioFromCollection(FirstNumberOutAudioFiles);
}

export async function speakGameEnd() {
  await playAudioFromCollection(thankyouMessageAudioFiles);
}

export async function speakTemplateEnd() {
  await playAudioFromCollection(gameEndAudioFiles); 
}

export async function parseTemplateStart() {
  await playAudioFromCollection(nextGameAudioFiles);
  await speakGamePattern("ONE_LINE");
  // await new Promise(resolve => setTimeout(resolve, 15000));
  await playAudioFromCollection(FirstNumberOutAudioFiles);
}

export async function speakGamePattern(winningPattern) {
  switch (winningPattern) {
    case "ONE_LINE":
      await playAudioFromCollection(playingSingleLineAudioFiles);
      break;

    case "TWO_LINE":
      await playAudioFromCollection(playingTwoLineAudioFiles);
      await playAudioFromCollection(NextNumberOutAudioFiles);
      break;

    case "FULL_HOUSE":
    case "JACKPOT":
      await playAudioFromCollection(playingFullHouseAudioFiles);
      break;

    default:
      console.warn("Unknown winning pattern:", winningPattern);
  }
}
